import { defineStore } from 'pinia'

export const useArchivingStore = defineStore('archiving', {
  state: () => ({
    autoArchivingDuration: null
  })
})
